import { Chip } from "@mui/material";
import { CreditStatus } from "../../Models/Credit";

interface CreditStatusLabelProps {
  status: CreditStatus;
}

const CreditStatusLabel: React.FC<CreditStatusLabelProps> = ({ status }) => {
  const getLabelProps = (status: CreditStatus) => {
    switch (status) {
      case CreditStatus.PAID:
        return { label: "Ödendi", color: "success" as "success" };
      case CreditStatus.UNPAID:
        return { label: "Ödenmemiş", color: "default" as "default" };
      case CreditStatus.LATE:
        return { label: "Gecikmiş", color: "warning" as "warning" };
      case CreditStatus.CANCELLED:
        return { label: "İptal Edildi", color: "error" as "error" };
      case CreditStatus.DELETED:
        return { label: "Silindi", color: "default" as "default" };
      default:
        return { label: "Bilinmiyor", color: "default" as "default" };
    }
  };

  const { label, color } = getLabelProps(status);

  return (
    <Chip
      sx={{ height: "24px" }}
      label={label}
      color={color}
      variant="filled"
    />
  );
};

export default CreditStatusLabel;
